import { render, staticRenderFns } from "./PersistApplication.vue?vue&type=template&id=45aec588&scoped=true"
import script from "./PersistApplication.vue?vue&type=script&lang=js"
export * from "./PersistApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aec588",
  null
  
)

export default component.exports